export function parseSearchString(searchString) {
  let term = searchString.trim();
  let type = "";
  const [first, ...rest] = term.split(" ");
  if (first.toLowerCase().indexOf("type:") === 0) {
    type = first
      .substring(first.indexOf(":") + 1)
      .trim()
      .toLowerCase();
    term = rest.join(" ").trim();
  }

  return {
    type,
    term
  };
}
